import { Button, ButtonProps } from '@mui/material';
import { styled } from '@mui/system';

const BG_COLOR_RGB = '7, 87, 91';
const MUTED_PRIMARY_BG_COLOR_RGB = '56, 121, 124';
const MUTED_PRIMARY_TEXT_COLOR_RGB = '131, 177, 179';

const StyledButton = styled(Button)(
    ({ variant, isClicked, disabled }: MuiButtonProps & ButtonProps) => ({
        padding: '0.4rem 1.2rem',
        border: `2px solid rgb(${BG_COLOR_RGB})`,
        textTransform: 'none',
        ...(variant === 'outlined'
            ? {
                  ...(isClicked
                      ? { background: `rgba(${BG_COLOR_RGB}, 0.1)` }
                      : {
                            color: `rgb(${BG_COLOR_RGB})`,
                        }),

                  '&:hover': {
                      background: `rgba(${BG_COLOR_RGB}, 0.1)`,
                      color: `rgb(${BG_COLOR_RGB})`,
                      border: `2px solid rgb(${BG_COLOR_RGB})`,
                  },
              }
            : {
                  background: `rgb(${BG_COLOR_RGB})`,
                  color: 'white',

                  '&:hover': {
                      background: `rgb(${MUTED_PRIMARY_BG_COLOR_RGB})`,
                      borderColor: `rgb(${MUTED_PRIMARY_BG_COLOR_RGB})`,
                  },
              }),
        ...(disabled &&
            (variant === 'outlined'
                ? {
                      background: `white`,
                      borderColor: `rgb(${MUTED_PRIMARY_BG_COLOR_RGB})`,
                      '&.Mui-disabled': {
                          color: `rgb(${MUTED_PRIMARY_TEXT_COLOR_RGB})`,
                      },
                  }
                : {
                      background: `rgba(${BG_COLOR_RGB}, 0.6)`,
                      borderColor: 'transparent',
                      '&.Mui-disabled': { color: 'white' },
                  })),

        '& .MuiButton-label': {
            display: 'flex',
            alignItems: 'center',
            gap: '0.4rem',
        },
    })
);

type MuiButtonProps = {
    isClicked?: boolean;
};

const MuiButton = ({ children, ...rest }: MuiButtonProps & ButtonProps) => {
    return <StyledButton {...rest}>{children}</StyledButton>;
};

export default MuiButton;
